// extracted by mini-css-extract-plugin
module.exports = {"container":"FactFileImageCarouselSlide_container__Cer8p","isPreview":"FactFileImageCarouselSlide_isPreview__lAtQK","isActive":"FactFileImageCarouselSlide_isActive__mI6V5"};